import {BasePanelPage} from "../../panels/BasePanelPage";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {apiChangeSubscription, SubscriptionApplyPolicy} from "../../../../../client/state/SubscriptionStore";
import {Messages} from "../../../../Messages";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {LabeledCheckbox} from "../../../../ui/Checkbox";
import {MerchantCheckbox} from "../../../../widget/ui/MerchantCheckbox";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PanelConstants";
import {Controller} from "../../../Controller";
import {Toast} from "../../../../ui/Toast.jsx";


export async function updateSubscription(subscriptionDetails) {
    subscriptionDetails = {
        subscriptionId: iFrameUserDataService.getActiveSubscription().id,
        ...subscriptionDetails,
    };

    LoadingSpinner.show();
    try {
        await apiChangeSubscription(subscriptionDetails);
    } catch (error) {
        Toast.showError(error);
    } finally {
        LoadingSpinner.hide();
    }

    // TODO @cleanup what, we may have has an error, we still go to success?
    Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess);
}

export class InlineUserDashboardSubscriptionChangeConfirmPanelStyle extends InlineUserDashboardPanelStyle {
    @styleRule
    checkbox = {
        color: "inherit",
        fontSize: "inherit",
        marginBottom: 8,
    };

    @styleRule
    lineSeparator = {
        width: "100%",
        borderBottom: "1px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
    };

    @styleRule
    reviewItemTitle = {
        textTransform: "uppercase",
        marginBottom: 8,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };
}

// TODO @cleanup so wonderful to see copy paste shit everywhere
@registerStyle(InlineUserDashboardSubscriptionChangeConfirmPanelStyle)
export class InlineUserDashboardSubscriptionChangeConfirmPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewChange,
        }
    }

    render() {
        const {selectedOffer, discountCode, applyPolicy} = Controller.subscriptionPlan;
        const instantPayInfo = Controller.subscriptionPlan.getDiscountInfoOnInstantChangePolicy(selectedOffer);
        const nextCyclePayInfo = Controller.subscriptionPlan.getDiscountInfo(selectedOffer);
        const activeSubscription = iFrameUserDataService.getActiveSubscription();
        const selectedCoverage = selectedOffer == null ? activeSubscription.coverage : selectedOffer.coverage;
        const selectedBillingPlan = selectedOffer == null ? activeSubscription.billingPlan : selectedOffer.billingPlan;

        const {styleSheet} = this;
        const paidUntil = activeSubscription.getPaidUntil();
        const nextBillingDate = activeSubscription.getNextBillingDate();

        const paymentInfoMessageArgs = [
            selectedBillingPlan.formatPrice(nextCyclePayInfo.finalPrice),
            selectedBillingPlan.getCycleDuration(true),
            nextBillingDate.format("MMM DD, YYYY")
        ];
        const updatePaymentInfo = applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE ? [
                Messages.updateAtEndCyclePaymentInfo(...paymentInfoMessageArgs),
                Controller.subscriptionPlan.userHasEquivalentSubscriptionToSelected() ? "" : Messages.updateAtEndCycleChangeOffer].join("")
            : Messages.updateInstantlyPaymentInfo(
                selectedBillingPlan.formatPrice(instantPayInfo.finalPrice),
                ...paymentInfoMessageArgs);

        let checkboxElement = null;
        if (instantPayInfo.finalPrice !== nextCyclePayInfo.finalPrice) {
            checkboxElement = <LabeledCheckbox className={styleSheet.checkbox}
                                               onChange={enabled => {
                                                   Controller.subscriptionPlan.applyPolicy = enabled ? SubscriptionApplyPolicy.NEXT_BILLING_CYCLE :
                                                       SubscriptionApplyPolicy.INSTANTLY;
                                                   this.redraw();
                                               }}
                                               CheckboxClass={MerchantCheckbox} initialValue={applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE}
                                               label={Messages.updateAtEndCycleCheckbox(paidUntil.format("MMM DD, YYYY"))}/>;
        }

        return [
            !Controller.subscriptionPlan.userHasEquivalentSubscriptionToSelected() ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.subscriptionPlan}</div>
                    <MessageElement message={Messages.updateSubscriptionPlanDescription(selectedCoverage.name, selectedBillingPlan.formatPrice(nextCyclePayInfo.finalPrice))}/>
                    <div className={styleSheet.lineSeparator}/>
                </div> : null,
            selectedCoverage.requiresAddress || (selectedOffer != null && selectedOffer.shouldCollectAddress()) ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.address}</div>
                    <MessageElement message={Messages.updateSubscriptionPlanAddress(Controller.address.selectedAddress.toString())}/>
                    <div className={styleSheet.lineSeparator}/>
                </div> : null,
            !Controller.subscriptionPlan.userHasEquivalentSubscriptionToSelected() ?
                <div>
                    <div className={styleSheet.reviewItemTitle}>{Messages.payment}</div>
                    {checkboxElement}
                    <MessageElement message={updatePaymentInfo}/>
                </div> : null,
            <MerchantButton label={Messages.changeSubscription} className={styleSheet.button}
                            onClick={() => updateSubscription({
                                applyPolicy,
                                recurringOfferId: selectedOffer == null ? null : selectedOffer.id,
                                userAddressId: Controller.address?.selectedAddress?.id,
                                discountCode: nextCyclePayInfo.discountValue ? discountCode : null,
                            })}/>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton} onClick={() => Router.back()}>
                    {Messages.back}
                </div>
            </div>
        ];
    }
}
